import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import axiosInstance from "../../../../redux/api";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { getIndustry } from "../../../../redux/categary/action";
import { useDispatch, useSelector } from "react-redux";

export default function ModalIndustry({
  formData,
  setFormData,
  setIndustryEditModal,
  industry_index
}) {
  const transformedCategory = {
    value: (formData?.industry_index?.value || formData.industry_id) ? (formData?.industry_index?.value || formData.industry_id) : "",
    label: (industry_index?.title || formData?.industry_index?.label) ? (industry_index?.title || formData?.industry_index?.label) : "Select Industry",
  };

  const dispatch = useDispatch();
  const [tempSubCategory, setTempSubCategory] = useState(transformedCategory);

  const TheIndustryList = useSelector(({ categary: { industrylist } }) => industrylist);

  useEffect(() => {
    dispatch(getIndustry());
  }, []);

  const handleValues = (options) => {
    setTempSubCategory(options);
  };

  const handleSave = () => {
    if (tempSubCategory) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        industry_index: tempSubCategory,
        industry_id: tempSubCategory.value,
        industry_title: tempSubCategory.label,
        category_index: "",
        category_id: "",
        subcategory_index: "",
        sub_category_id: "",
      }));
    }
    setIndustryEditModal((state) => !state);
  };

  console.log(tempSubCategory, 'tempSubCategory');

  return (
    <>
      <button
        onClick={() => setIndustryEditModal((state) => !state)}
        className ="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Edit Industry</h4>
        <ReactSelect
          options={
            Array.isArray(TheIndustryList) &&
            TheIndustryList?.map((lang) => ({
              value: lang.id,
              label: lang.title,
            }))
          }
          placeholder="Select Industry"
          value={tempSubCategory}
          onChange={(options) => {
            if (options) {
              handleValues(options);
            }
          }}
        />
      </ModalBody>
      <div className ="modal-footer">
        <button className ="btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </>
  );
}
